<template>
  <div class="break row-box">
    <WrapperField
      v-for="(value, index) in data"
      :key="value + index + Math.random()"
      :data="
        createDataField({
          fieldName: index,
          fieldValue: value,
          fieldGroup,
          fieldGroupEdit,
        })
      "
    ></WrapperField>
  </div>
</template>

<script>
import { createDataField, FieldGroup } from '@/utils/fullStatementView';
import WrapperField from '@/components/elements/statement/FullStatementView/base/WrapperField';

export default {
  name: 'Block',
  props: {
    data: {
      type: Object,
      required: true,
    },
    fieldGroup: {
      type: String,
      required: true,
    },
    fieldGroupEdit: {
      type: String,
    }
  },
  components: {
    WrapperField,
  },
  data: () => ({
    createDataField,
    FieldGroup,
  }),
};
</script>
